<template>
  <ClientOnly>
    <zapier-interfaces-chatbot-embed
      is-popup="true"
      :chatbot-id="config.public.zapier.chatbotId"
    />
  </ClientOnly>
</template>

<script lang="ts" setup>
const config = useRuntimeConfig()
</script>
